import { property } from 'lodash';

export function getAvailableTabs(tenant, user, client) {
  if (!client || !client.is_active) {
    // We need the client to know where to link to
    return [];
  }

  const tabs = [
    {
      name: `Home`,
      id: 'home',
      url: `/#/client/${client.id}`,
      matches: ["#/client/[0-9]+/?$"],
    },
    {
      name: `Files`,
      id: 'files',
      url: `/#/docs/clients/${client.id}/files`,
      matches: ["#.*files.*"],
      permission: permissions => permissions.client_files
    },
    {
      name: `Billing`,
      id: 'billing',
      url: `/#/client/${client.id}/billing`,
      matches: [`#/client/${client.id}/billing`],
      permission: (permissions) => {
        return permissions.client_billing;
      }
    },
    {
      name: `Requests`,
      id: 'requests',
      url: `/#/client/${client.id}/requests`,
      matches: ["#/client/[0-9]+/requests"],
      permission: property("client_requests"),
    },
    {
      name: `Surveys`,
      id: 'surveys',
      url: `/#/forms/clients/${client.id}/surveys`,
      matches: ["#.*survey.*"],
      permission: () => true // everyone should see surveys now that practice management is a contact limit based model
    },
    {
      name: 'Tax Preparation',
      id: 'tax_returns',
      url: `/#/clients/${client.id}/tax-returns`,
      matches: ["#.*tax-returns.*"],
      permission: property("client_tax_prep")
    },
  ];

  return tabs.filter((tab) => {
    return tab.permission ? tab.permission(user.effective_permissions) : true;
  });
}
